import React, { useState } from "react"
import PropTypes from "prop-types"
import { AvField } from "availity-reactstrap-validation"
import DatePicker from "react-datepicker"
import moment from "moment"
import { MentionsInput, Mention } from "react-mentions"
import TimePicker from "react-times"
import { getCurrentUser } from "../../../helpers/Utils"
import { toast } from "react-toastify"
import { Link } from "react-router-dom"
import "react-datepicker/dist/react-datepicker.css"
import "react-times/css/material/default.css"

const SendReminderSection = ({
  clientMessages,
  handleMessageChange,
  reminderDate,
  setReminderDate,
  reminderTime,
  setReminderTime,
  singleLineValue,
  handleChangeSingle,
  variableData,
  onSetReminder,
  loading,
  leadData,
}) => {
  const [sendToPrimary, setSendToPrimary] = useState(true)
  const [sendToLeadholder, setSendToLeadholder] = useState(false)
  const [ccToMe, setCcToMe] = useState(false)

  const user = getCurrentUser()
  const hasWhatsAppCredentials =
    user?.admin_whatsapp_username && user?.admin_whatsapp_token

  const handleTimeChange = time => {
    let hours
    if (time.meridiem === "AM") {
      hours = time.hour
    } else {
      hours = parseInt(time.hour) + 12
    }
    let timeString = `${hours}:${time.minute}`
    setReminderTime(timeString)
  }

  const handleSubmit = () => {
    if (!hasWhatsAppCredentials) {
      toast.error(
        "WhatsApp token details are missing. Please update your profile with WhatsApp credentials.",
        {
          position: "top-center",
          autoClose: 5000,
        }
      )
      return
    }

    onSetReminder({
      sendToPrimary,
      sendToLeadholder,
      ccToMe: sendToPrimary && ccToMe,
    })
  }

  return (
    <div className="mb-3 position-relative">
      {!hasWhatsAppCredentials && (
        <div
          className="position-absolute w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            backdropFilter: "blur(1px)",
            zIndex: 10,
            borderRadius: "4px",
          }}
        >
          <div className="text-center">
            <i
              className="mdi mdi-alert-circle-outline text-danger"
              style={{ fontSize: "48px" }}
            ></i>
            <h5 className="text-danger mt-2">WhatsApp Credentials Required</h5>
            <p className="text-muted">
              Please update your profile with WhatsApp token details to set
              reminders.
            </p>
            <Link to="/profile" className="btn btn-primary btn-sm">
              <i className="mdi mdi-account-circle me-1"></i>
              Go to Profile
            </Link>
          </div>
        </div>
      )}
      {clientMessages.length ? (
        <div className="mb-3">
          <AvField
            className="select-arrow"
            type="select"
            name="message_title"
            onChange={e => handleMessageChange(e)}
          >
            <option value="">Select Message</option>
            {clientMessages?.map((item, i) => (
              <option value={item.id} key={i}>
                {item.name}
              </option>
            ))}
          </AvField>
        </div>
      ) : (
        ""
      )}
      <div className="d-flex">
        <div className="mb-3 pe-2 required">
          <label className="form-group">Select Date</label>
          <DatePicker
            className="w-100 form-control"
            dateFormat="yyyy-MM-dd"
            name="reminder_date"
            selected={reminderDate}
            minDate={moment().toDate()}
            onChange={date => setReminderDate(date)}
          />
        </div>
        <div className="mb-3 required">
          <label className="form-group">Select Time</label>
          <TimePicker
            name="reminder_time"
            time={reminderTime}
            theme="material"
            timeMode="12"
            onTimeChange={e => handleTimeChange(e)}
          />
        </div>
      </div>
      <div className="mb-3 required w-100">
        <label>Whatsapp Message</label>
        <MentionsInput
          value={singleLineValue}
          onChange={handleChangeSingle}
          markup="@{{__type__||__id__||__display__}}"
          placeholder="Type anything, use the @ symbol to select variables."
          className="mentions"
          required
        >
          <Mention
            type="user"
            trigger="@"
            data={variableData}
            className="mentions__mention"
          />
        </MentionsInput>
        <small className="fst-italic">{`Use @ to select variables to create message.`}</small>
      </div>
      <div className="mb-3">
        <label className="form-label fw-bold">Select Sender:</label>
        <div className="d-flex flex-wrap align-items-start">
          <div className="form-check me-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="sendToPrimary"
              checked={sendToPrimary}
              onChange={e => {
                setSendToPrimary(e.target.checked)
                if (!e.target.checked) {
                  setCcToMe(false)
                }
              }}
            />
            <label className="form-check-label" htmlFor="sendToPrimary">
              Primary Number
            </label>
          </div>
          <div className="form-check me-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="sendToLeadholder"
              checked={sendToLeadholder}
              onChange={e => setSendToLeadholder(e.target.checked)}
            />
            <label className="form-check-label" htmlFor="sendToLeadholder">
              Leadholder's Number
            </label>
          </div>
          {sendToPrimary && (
            <div className="form-check me-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="ccToMe"
                checked={ccToMe}
                onChange={e => setCcToMe(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="ccToMe">
                CC to me
              </label>
            </div>
          )}
        </div>
      </div>
      <div className="text-center mt-3">
        {loading ? (
          <button className="btn btn-primary disabled" type="button" disabled>
            Setting Reminder...
          </button>
        ) : (
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleSubmit}
            disabled={
              !reminderDate ||
              !reminderTime ||
              !singleLineValue ||
              (!sendToPrimary && !sendToLeadholder)
            }
          >
            Set Reminder
          </button>
        )}
      </div>
    </div>
  )
}

SendReminderSection.propTypes = {
  clientMessages: PropTypes.array.isRequired,
  handleMessageChange: PropTypes.func.isRequired,
  reminderDate: PropTypes.instanceOf(Date),
  setReminderDate: PropTypes.func.isRequired,
  reminderTime: PropTypes.string.isRequired,
  setReminderTime: PropTypes.func.isRequired,
  singleLineValue: PropTypes.string.isRequired,
  handleChangeSingle: PropTypes.func.isRequired,
  variableData: PropTypes.array.isRequired,
  onSetReminder: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  leadData: PropTypes.object,
}

export default SendReminderSection
